module.exports = __webpack_public_path__ + "img/noArrow.c0cc6349.png";